import { useState } from 'react';
import React from 'react';

import { Card, Modal, message } from 'antd';

import sessionManager, { eVariableType } from '../../../SessionManager';
import { GetFormattedDataOra } from '../../../Utility';
import api from '../../../api';
import stringres from '../../../translations/stringres';
import Allegati from '../../Allegati';
import MenuAddEdit from '../../Common/MenuAddEdit';
import OpportunitaAttivitaAddEdit from '../OpportunitaAttivita/OpportunitaAttivitaAddEdit';

export default function OpportunitaAttivita({ item, reload }) {
    const [selectedAttivita, setSelectedAttivita] = useState(null);
    const [openAddEdit, setOpenAddEdit] = useState(false);
    const [openAllegati, setOpenAllegati] = useState(false);

    function checkDataScadenza(item) {
        if (item.tipo === 'E') return;

        const dscad = new Date(item.dataScadenza).getTime();

        if (dscad === 0) return;
        else
            return (
                <div>
                    {
                        <span>
                            {stringres.t('datascadenza')}{' '}
                            <GetFormattedDataOra data={item.dataUltima}></GetFormattedDataOra>
                        </span>
                    }
                    <br></br>
                </div>
            );
    }

    function onAllega() {
        setOpenAllegati(true);
    }

    function titolo(itm) {
        let mnu;
        if (itm.tipo === 'A')
            mnu = (
                <div className="right-div">
                    <MenuAddEdit
                        attivaAllegato={true}
                        onModifica={onModificaAttivita}
                        onCancella={onCancellaAttivita}
                        onSelectRow={() => onSelectRow(itm)}
                        onAllega={onAllega}
                    ></MenuAddEdit>
                </div>
            );
        return (
            <div className="container">
                <div className="left-div">
                    <span>{itm.descrizioneTipo}</span>
                    <span className="card-title">
                        {' '}
                        <GetFormattedDataOra data={itm.dataUltima}></GetFormattedDataOra>
                    </span>
                </div>
                {mnu}
            </div>
        );
    }

    function onSelectRow(it) {
        setSelectedAttivita(it);
    }

    function onModificaAttivita(e) {
        try {
            setOpenAddEdit(true);

            console.log(selectedAttivita);
        } catch (error) {
            message.error(error.message);
        }
    }
    async function onCancellaAttivita() {
        try {
            const response = await api.delete(
                'CRM/Opportunita/Attivita/Delete?idSocieta=' +
                    sessionManager.get(eVariableType.IDSocieta) +
                    '&idAttivitaOpportunita=' +
                    selectedAttivita.idAttivitaOpportunita
            );
            if (response != null && response.status === 200) {
                message.success(stringres.t('successo'));
                reload();
            }
        } catch (error) {
            message.error(error.response.data.message);
        }
    }

    function onConfirm(e) {
        setOpenAddEdit(false);
        reload();
    }

    return (
        <div>
            <Card headStyle={{ border: 0 }} size="small" title={titolo(item)}>
                {checkDataScadenza(item)}
                {item.oggetto}
            </Card>
            <Modal
                title={stringres.t('attivitaaddedit')}
                open={openAddEdit}
                onCancel={() => setOpenAddEdit(false)}
                footer={null}
                destroyOnClose={true}
            >
                <OpportunitaAttivitaAddEdit
                    idOpportunita={item.idOpportunita}
                    AttivitaOpportunita={selectedAttivita}
                    confirm={onConfirm}
                ></OpportunitaAttivitaAddEdit>
            </Modal>
            <Modal
                width={800}
                title={stringres.t('allegati')}
                open={openAllegati}
                onCancel={() => setOpenAllegati(false)}
                footer={null}
                destroyOnClose="True"
            >
                <Allegati
                    idOpportunita={item.idOpportunita}
                    idAttivitaOpportunita={item.idAttivitaOpportunita}
                ></Allegati>
            </Modal>
        </div>
    );
}
